import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { trakrefBlue, inputGrey, Grey3, Grey4 } from "../../../color_utils";
import PropTypes from "prop-types";
import { trakrefFontFamily, trakrefFontFamilySemiBold } from "../../../utils";


const defaultStlyes = {
    "& label.Mui-focused": {
        color: trakrefBlue,
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "& .MuiFilledInput-root": {
        backgroundColor: inputGrey,
        "&.Mui-focused fieldset": {
            borderColor: trakrefBlue,
        },
    },
    "& .MuiFilledInput-root.Mui-disabled": {
        backgroundColor: Grey4
    },
    '& .MuiFormLabel-root': { fontFamily: trakrefFontFamily },
    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
        textTransform: "uppercase",
        fontFamily: trakrefFontFamilySemiBold
    },
    "&  .MuiFormLabel-root.MuiInputLabel-root.Mui-error": {
        color: "#D51A1A !important",
        fontFamily: trakrefFontFamilySemiBold,
    },
    "& .MuiInputBase-root.MuiInput-underline.Mui-error:after": {
        borderBottom: "2px solid #D51A1A !important",
    },
    "& .MuiFilledInput-root:after": { borderBottomColor: trakrefBlue },
};

const validateValue = (value) => {

    if (!value) return;

    const isValid = String(value)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );

    return !isValid;
};

const errorMessage = "Please enter a valid email address. (For example : email@email.com)";

const InputEmail = ({
    id,
    required,
    label,
    value,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    error,
    fullWidth,
    variant,
    helperText,
    multiLine,
    type,
    disabled,
    rows,
    maxCharacterLength,
    sx,
    isValid,
    className
}) => {
    const [currentError, setCurrentError] = useState(error);
    const [currentHelperText, setCurrentHelperText] = useState(errorMessage);

    useEffect(() => {
        setCurrentHelperText(helperText);
    }, [helperText]);

    useEffect(() => {
        const isValidValue = validateValue(value);
        const errorExist = isValidValue || error;

        setCurrentError(errorExist);
        setCurrentHelperText(isValidValue ? errorMessage : helperText);
    }, [value, error]);

    useEffect(() => {
        isValid(currentError);
    }, [currentError]);

    return (
        <TextField
            id={id}
            required={required}
            disabled={disabled}
            InputProps={{
                notched: !!value || value === 0,
                inputProps: {
                    sx: {
                        "&::placeholder": {
                            color: Grey3,
                            opacity: 1,
                            fontSize: '16px',
                        },
                        fontFamily: trakrefFontFamily
                    },
                    maxLength: maxCharacterLength,
                }
            }}
            InputLabelProps={{
                shrink: !!value || value === 0,
                sx: {
                    fontFamily: trakrefFontFamilySemiBold
                }
            }}
            label={label}
            value={value}
            defaultValue={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            error={currentError}
            rows={rows}
            fullWidth={fullWidth}
            variant={variant}
            helperText={currentError ? currentHelperText : ""}
            multiline={multiLine}
            type={type}
            sx={{ ...defaultStlyes, ...sx }}
            className={className}
        />
    );
};

InputEmail.propTypes = {
    required: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    error: PropTypes.bool,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    helperText: PropTypes.string,
    multiLine: PropTypes.bool,
    numberInput: PropTypes.string,
    disabled: PropTypes.bool,
    maxCharacterLength: PropTypes.number,
    id: PropTypes.string,
    sx: PropTypes.object,
    className: PropTypes.any,
    isValid: PropTypes.func,
};

InputEmail.defaultProps = {
    required: false,
    disabled: false,
    error: false,
    fullWidth: false,
    variant: "outlined",
    helperText: "This field is required",
    multiLine: false,
    numberInput: "",
    onFocus: () => { },
    onBlur: () => { },
    onKeyDown: () => { },
    maxCharacterLength: 50000,
    id: "",
    sx: {},
    isValid: () => { },
};

export default InputEmail;
